import { CtrlType } from "@yuigoto/ctrl";

export const DuvidasControl = [

    {
        name: "influencerHelpTypeId",
        required: true,
        label: "Qual o motivo do contato?",
        requiredMessage: "Este campo é obrigatório.",
        type: CtrlType.DROPDOWN,
        options: [{ "value": null, "name": "Escolha uma opção" },
        { "value": 1, "name": "Comissão está errada" },
        { "value": 2, "name": "Problema com o link da Campanha" },
        { "value": 3, "name": "Não consigo acessar o menu" },
        { "value": 4, "name": "Meu cupom está com problemas" },
        { "value": 5, "name": "Outros (descreva abaixo)" }
        ]
    },
    {
        name: "help",
        required: false,
        label: "Por favor, descreva o ocorrido abaixo:",
        type: CtrlType.TEXTAREA,
        rows: 3
    }

];